/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Email
 *
 * 1 = Sms
 */
export enum TwoFactorType {
  Email = 0,
  Sms = 1,
}
